import { useWebsitePageListQuery } from '@graphql/generated';
import { useEventInfo } from '@shared/utils/eventInfo';

export function useWebsitePageList(variables?: Parameters<typeof useWebsitePageListQuery>[0]) {
  const { eventInfo } = useEventInfo();
  const eventId = eventInfo?.eventId;

  const { data, loading, error, refetch } = useWebsitePageListQuery({
    variables: { eventId: eventId ?? '' },
    batchMode: 'off',
    ssr: true,
  });

  const pages = data?.eventById?.pages ?? [];
  return {
    pages,
    loading,
    error,
    refetch,
  };
}
